import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface Tenant {
  id: string;
  name: string;
  logoUrl?: string;
}

interface TenantState {
  // Current tenant
  tenant: Tenant | null;
  isLoading: boolean;

  // Actions
  setTenant: (tenant: Tenant | null) => void;
  setLoading: (loading: boolean) => void;
  clearTenant: () => void;
}

export const useTenantStore = create<TenantState>()(
  devtools(
    (set) => ({
      // Initial state
      tenant: null,
      isLoading: false,

      // Actions
      setTenant: (tenant) => set({ tenant, isLoading: false }),

      setLoading: (loading) => set({ isLoading: loading }),

      clearTenant: () => set({ tenant: null }),
    }),
    { name: 'TenantStore' }
  )
);
